// @flow

// NOTE: This Flow module has a corresponding ambient TypeScript declaration in app/types/flow-modules.d.ts. Keep them in sync until this file is migrated to TypeScript.

import { type UserInputValidationError } from '@tectonics/prs/validation';

const TR_PHONE_REGEX = /^\+90\s?5\d{2}\s?\d{3}\s?\d{2}\s?\d{2}$/;

export function validateTurkeyPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim()) {
    return { id: 'empty' };
  }

  if (!TR_PHONE_REGEX.test(phoneNumberValue)) {
    return { id: 'invalid-pattern' };
  }
}
